export default __webpack_public_path__ + "static/media/junk-removal.64de16a9.svg";